import { useMutation } from "@apollo/client";
import { Localizer, Text } from "preact-i18n";
import { Button, Tooltip } from "@mui/material";

import { GenerateObfuscatedAddressMutation } from "./NewObfuscatedAddressButton.graphql";
import { ObfuscatedAliasesQuery } from "../ObfuscationDashboard/ObfuscationDashboard.graphql";
const NewObfuscatedAddressButton = () => {
  const [generate] = useMutation(GenerateObfuscatedAddressMutation, {
    refetchQueries: [{ query: ObfuscatedAliasesQuery }],
  });

  return (
    <Localizer>
      <Tooltip title={<Text id="NewObfuscatedAddressButton.tooltip" />}>
        <Button
          color="inherit"
          size="small"
          className="mr-2 whitespace-nowrap w-full"
          variant="outlined"
          onClick={async () => {
            const { data } = await generate();

            await navigator.clipboard.writeText(
              data.createObfuscatedAlias.address
            );
          }}
        >
          <Text id="NewObfuscatedAddressButton.label" />
        </Button>
      </Tooltip>
    </Localizer>
  );
};

export default NewObfuscatedAddressButton;
